"use client";

import Image from "next/image";
import Link from "next/link";

interface VideoThumbnailsProps {
  videos: Array<{
    id: number;
    thumbnail: string;
    video: string;
    alt: string;
  }>;
  onThumbnailClick: (videoUrl: string) => void;
  buttonText: string;
  buttonMobileText: string;
  buttonHref: string;
  buttonMobileHref: string;
}

export function VideoThumbnails({ 
  videos, 
  onThumbnailClick, 
  buttonText, 
  buttonMobileText,
  buttonHref,
  buttonMobileHref 
}: VideoThumbnailsProps) {
  return (
    <div>
      <div className="mt-12 hidden space-x-6 lg:flex">
        {videos.map(({ id, thumbnail, video, alt }) => (
          <button
            key={id}
            onClick={() => onThumbnailClick(video)}
            className="group relative h-32 w-32 overflow-hidden rounded-full border border-white"
          >
            <Image
              src={thumbnail}
              alt={alt}
              fill
              className="object-cover transition-transform duration-300 group-hover:scale-110"
              sizes="128px"
            />
            <div className="absolute left-0 top-0 inset-0 flex items-center justify-center bg-black/40 transition-opacity group-hover:bg-black/20">
              <Image
                src="/images/video-circle.svg"
                alt="Play video"
                width={53}
                height={53}
              />
            </div>
          </button>
        ))}
      </div>
      <Link 
        href={(typeof window !== "undefined" && window.innerWidth < 1280 ? buttonMobileHref : buttonHref) || "#"}
        className="mt-8 inline-block w-full rounded-full bg-primary px-12 py-4 font-greycliff text-xl text-white text-center xl:mt-16 xl:w-auto"
      >
        <span className="xl:hidden whitespace-nowrap">{buttonMobileText}</span>
        <span className="hidden xl:inline">{buttonText}</span>
      </Link>
    </div>
  );
} 